import { Box, Stack, styled, Typography, type CSSObject } from '@mui/material';
import { theme } from '@rumblefish/ui';

export const StyledStack = styled(Stack)(({ theme }) => ({
  flexFlow: 'column nowrap',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(12, 0),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(8, 0),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(6, 0),
  },
}));

export const StyledFirstTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  letterSpacing: '-0.02em',
  display: 'flex',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  marginBottom: theme.spacing(8),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: 'auto',
    textAlign: 'center',
    marginBottom: theme.spacing(4),
  },
}));

export const StyledSecondTitle = styled(Typography)(
  ({ theme: { breakpoints } }) => ({
    ...(theme.mixins.neutralGradient as CSSObject),
    color: 'white',
    letterSpacing: '-0.02em',
    display: 'flex',
    [breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  })
);

export const StyledServiceItem = styled(Box)(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    borderRadius: theme.spacing(4),
    gap: theme.spacing(3),
    border: `1px solid ${theme.palette.greyBorder?.LIGHT + '35'}`,
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      width: '100%',
    },
  };
});

export const StyledServiceIconWrapper = styled('div')(({ theme }) => ({
  background:
    'radial-gradient(47.45% 48.31% at -0.77% 0%, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 100%), rgba(255, 255, 255, 0.03);',
  width: '80px',
  minWidth: '80px',
  height: '80px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(1),
  },
}));

export const StyledServiceIconBackground = styled('div')(({}) => ({
  background: 'rgba(246, 163, 81,0.05)',
  width: '60px',
  height: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
}));
export const StyledServiceIcon = styled('img')(({}) => ({
  background: 'transparent',
  position: 'relative',
  height: '43px',
  aspectRatio: '1/1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledServiceTitle = styled(Typography)(({}) => ({
  letterSpacing: '-0.02em',
  background:
    'linear-gradient(180deg, #FFFFFF 0%, rgba(217, 217, 217, 0.8) 100%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}));

export const StyledServiceDescription = styled(Typography)(() => ({
  color: '#ABB1B4',
  lineHeight: '150%',
  letterSpacing: '-0.01em',
  // textAlign: 'center',
}));
